import { render, staticRenderFns } from "./menuTab.vue?vue&type=template&id=74652246&lang=pug"
import script from "./menuTab.vue?vue&type=script&lang=js"
export * from "./menuTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports